import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

import Home from "./pages/homepage";
import Login from "./pages/Login";
import Signup from "./pages/signup";
import Dashboard from "./pages/Dashboard";
import AddProperty from "./pages/Addproperty";
import ViewReports from "./pages/ViewReports";
import ProtectedRoute from "./ProtectedRoute";
import ExpertDashboard from "./pages/ExpertDashboard";
import ExpertConsult from "./pages/ExpertConsult";
import ExpertChat from "./pages/ExpertChat";
import Consult from "./pages/Consult";
import BookAppointment from "./pages/BookAppointment";
import MyAppointments from "./pages/MyAppointments";
import SupportChatbot from "./components/SupportChatbot";


import Terms from "./pages/Legal/Terms";
import Privacy from "./pages/Legal/Privacy";
import RefundPolicy from "./pages/Legal/RefundPolicy";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
    });
    return () => unsub();
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-property"
            element={
              <ProtectedRoute>
                <AddProperty />
              </ProtectedRoute>
            }
          />

          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <ViewReports />
              </ProtectedRoute>
            }
          />
          <Route path="/chat" element={<Consult />} />

          <Route
            path="/expert/dashboard"
            element={
              <ProtectedRoute>
                <ExpertDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/expert/consult/:propertyId"
            element={
              <ProtectedRoute>
                <ExpertConsult />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-appointments"
            element={
              <ProtectedRoute>
                <MyAppointments />
              </ProtectedRoute>
            }
          />


          <Route
            path="/expert/chat/:userId"
            element={
              <ProtectedRoute>
                <ExpertChat />
              </ProtectedRoute>
            }
          />

          <Route
            path="/book-appointment"
            element={
              <ProtectedRoute>
                <BookAppointment />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />


        </Routes>
      </BrowserRouter>
      {user && <SupportChatbot />}
    </>
  );

}

export default App;
